interface AuditRow {
  actionAt: string; action: string; entity: string;
  priorValue: unknown; newValue: unknown; operatorEmail: string;
}

export function AuditRow({ row }: { row: AuditRow }) {
  return (
    <div className="card">
      <div className="card-header">
        <strong>{row.action}</strong>
        <span className="muted">{new Date(row.actionAt).toLocaleString()}</span>
      </div>
      <div className="muted" style={{ fontSize: 'var(--fs-sm)' }}>
        {row.entity} · by {row.operatorEmail}
      </div>
      <div style={{ marginTop: 'var(--sp-2)', fontFamily: 'ui-monospace, monospace', fontSize: 'var(--fs-xs)' }}>
        <div>prior: <code>{JSON.stringify(row.priorValue)}</code></div>
        <div>new:   <code>{JSON.stringify(row.newValue)}</code></div>
      </div>
    </div>
  );
}
